<app-modal-mensagem
  *ngIf="sucessoRelato"
  tipo="sucesso"
  titulo="Sucesso!"
  mensagem="Relato criado com sucesso!"
  (confirmar)="continuar()"
></app-modal-mensagem>

<div class="modal-panel-tarefa">
  <div class="modal-header">
    <div class="modal-header-left">
      <div class="modal-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <line x1="10" y1="9" x2="11" y2="9" />
        </svg>
      </div>
      <div>
        <h2 class="modal-title">Novo relato</h2>
        <p class="modal-subtitle">Descreva o relato da obra</p>
      </div>
    </div>
    <button class="btn-close" type="button" (click)="continuar()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group">
      <label class="form-label" for="descricaoRelato">
        Seu relato
        <span class="required">*</span>
      </label>
      <textarea
        id="descricaoRelato"
        [(ngModel)]="descricaoRelato"
        placeholder="Descreva o seu relato..."
        class="form-textarea"
        rows="5"
      ></textarea>
    </div>

    <div class="form-group">
      <label class="form-label" for="nomeRelato"> Título do relato </label>
      <input
        id="nomeRelato"
        type="text"
        [(ngModel)]="nomeRelato"
        placeholder="Gostaria de dar um nome para seu relato?"
        class="form-input"
      />
    </div>

    <div class="form-group checkbox-group">
      <label class="checkbox-label">
        <input type="checkbox" [(ngModel)]="enviarEmail" />
        <span>Enviar informações por e-mail</span>
      </label>
    </div>

    <div class="form-group">
      <label class="form-label"> Contatos </label>
      <app-filtro-select-busca
        [multi]="true"
        [options]="contatoOptions"
        [(selectedValues)]="selectedResponsaveis"
        [disabled]="!enviarEmail"
        placeholder="Selecione os contatos"
        placeholderBusca="Buscar contato..."
      ></app-filtro-select-busca>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn-secondary" type="button" (click)="clear()">
      Limpar dados
    </button>
    <button
      class="btn-primary"
      type="button"
      (click)="criarRelato()"
      [disabled]="carregandoRelato"
    >
      Criar relato
    </button>
  </div>
</div>
